var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        width: "85",
        "footer-hide": true,
        title: "发货单",
        scrollable: true,
      },
      on: { "on-visible-change": _vm.onShowChange },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.innerSpin
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "Card",
        { attrs: { padding: 0, bordered: false, "dis-hover": true } },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c("div", { staticClass: "left-bar" }),
                  _vm.$checkAccessArray(["B", "C", "D"]) &&
                  _vm.preSaleDeliveryRecord.preSaleDeliveryRecordStatus !=
                    "关闭"
                    ? _c(
                        "div",
                        {
                          staticClass: "right-bar",
                          staticStyle: { "margin-bottom": "20px" },
                        },
                        [
                          _vm.showPoptip
                            ? _c(
                                "Poptip",
                                {
                                  staticStyle: { "margin-right": "20px" },
                                  attrs: {
                                    confirm: "",
                                    placement: "left",
                                    title: "是否已确认所有信息无误？",
                                  },
                                  on: {
                                    "on-ok": _vm.ok,
                                    "on-cancel": _vm.cancel,
                                  },
                                },
                                [
                                  _c("Button", { attrs: { type: "error" } }, [
                                    _vm._v("确认发货"),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "Button",
                            {
                              attrs: { type: "success" },
                              on: {
                                click: function ($event) {
                                  return _vm.printDeliveryRecord()
                                },
                              },
                            },
                            [_vm._v("打印发货单")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "Form",
                    {
                      ref: "deliveryForm",
                      attrs: {
                        "label-position": "top",
                        rules: _vm.ruleValidate,
                      },
                    },
                    [
                      _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "发货单号" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value: _vm.preSaleDeliveryRecord.billCode,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "关联定金单号" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.preSaleDeliveryRecord
                                          .preSaleDeliveryRecordRelateOrderRecordCode,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "会员号" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value: _vm.preSaleDeliveryRecord.userName,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "会员电话" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.preSaleDeliveryRecord
                                          .userExternalCustomerContactNumber,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "发货日期" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value: _vm.formatDateString(
                                        _vm.preSaleDeliveryRecord
                                          .preSaleDeliveryRecordDeliveryDate
                                      ),
                                    },
                                    model: {
                                      value: _vm.sendDeliveryDate,
                                      callback: function ($$v) {
                                        _vm.sendDeliveryDate = $$v
                                      },
                                      expression: "sendDeliveryDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "制单时间" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value: _vm.formatDateTimeString(
                                        _vm.preSaleDeliveryRecord
                                          .preSaleDeliveryRecordCreateAt
                                      ),
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "实际发货量" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.preSaleDeliveryRecord
                                          .receiveQuantity,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "抛头/赠送率(%)" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.preSaleDeliveryRecord
                                          .additionalRate,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "本批发货量" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.preSaleDeliveryRecord
                                          .preSaleDeliveryRecordTotalQuantity,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "制单人" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.preSaleDeliveryRecord.billMaker,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "发货方式" } },
                                [
                                  _c(
                                    "RadioGroup",
                                    {
                                      attrs: { type: "button", size: "large" },
                                      on: {
                                        "on-change": _vm.onDeliveryWaysChange,
                                      },
                                      model: {
                                        value:
                                          _vm.preSaleDeliveryRecord
                                            .deliveryWays,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.preSaleDeliveryRecord,
                                            "deliveryWays",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "preSaleDeliveryRecord.deliveryWays",
                                      },
                                    },
                                    _vm._l(
                                      _vm.deliveryWaysList,
                                      function (item, index) {
                                        return _c(
                                          "Radio",
                                          {
                                            key: item.val,
                                            attrs: { label: item.val },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.label) +
                                                "\n\t\t\t\t\t\t\t\t   "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showTransferStation,
                                  expression: "showTransferStation",
                                },
                              ],
                              attrs: { span: "4" },
                            },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "转运站" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: {
                                        disabled: _vm.isShowUpdateDisBtn,
                                        filterable: "",
                                        clearable: "",
                                      },
                                      model: {
                                        value:
                                          _vm.preSaleDeliveryRecord
                                            .relateDistributionStationUuid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.preSaleDeliveryRecord,
                                            "relateDistributionStationUuid",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "preSaleDeliveryRecord.relateDistributionStationUuid",
                                      },
                                    },
                                    _vm._l(
                                      _vm.stationList,
                                      function (item, index) {
                                        return _c(
                                          "Option",
                                          {
                                            key: item.distributionStationUuid,
                                            attrs: {
                                              value:
                                                item.distributionStationUuid,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.distributionStationName
                                              )
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showTransferStation,
                                  expression: "showTransferStation",
                                },
                              ],
                              attrs: { span: "4" },
                            },
                            [
                              _vm.$checkAccessArray(["D", "S"])
                                ? _c(
                                    "FormItem",
                                    { attrs: { label: "当前转运站收运费" } },
                                    [
                                      _c("Input", {
                                        model: {
                                          value:
                                            _vm.preSaleDeliveryRecord
                                              .currentDeliveryFee,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.preSaleDeliveryRecord,
                                              "currentDeliveryFee",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "preSaleDeliveryRecord.currentDeliveryFee",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showLogistics,
                                  expression: "showLogistics",
                                },
                              ],
                              attrs: { span: "4" },
                            },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "物流单号" } },
                                [
                                  _c("Input", {
                                    model: {
                                      value:
                                        _vm.preSaleDeliveryRecord.logisticsCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.preSaleDeliveryRecord,
                                          "logisticsCode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "preSaleDeliveryRecord.logisticsCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showLogistics,
                                  expression: "showLogistics",
                                },
                              ],
                              attrs: { span: "4" },
                            },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "物流公司" } },
                                [
                                  _c("Input", {
                                    model: {
                                      value:
                                        _vm.preSaleDeliveryRecord
                                          .preSaleDeliveryRecordLogisticsCompanyName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.preSaleDeliveryRecord,
                                          "preSaleDeliveryRecordLogisticsCompanyName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "preSaleDeliveryRecord.preSaleDeliveryRecordLogisticsCompanyName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "是否返回定金" } },
                                [
                                  _c(
                                    "RadioGroup",
                                    {
                                      attrs: { type: "button" },
                                      model: {
                                        value:
                                          _vm.preSaleDeliveryRecord
                                            .isReturnDepositFee,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.preSaleDeliveryRecord,
                                            "isReturnDepositFee",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "preSaleDeliveryRecord.isReturnDepositFee",
                                      },
                                    },
                                    [
                                      _c(
                                        "Radio",
                                        { key: 1, attrs: { label: 1 } },
                                        [_vm._v("是")]
                                      ),
                                      _c(
                                        "Radio",
                                        { key: 0, attrs: { label: 0 } },
                                        [_vm._v("否")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.isShowUpdateDisBtn
                            ? _c(
                                "Col",
                                { attrs: { span: "4", offset: "16" } },
                                [
                                  _c(
                                    "Button",
                                    {
                                      attrs: { type: "info" },
                                      on: {
                                        click: _vm.ShowDistributionStation,
                                      },
                                    },
                                    [_vm._v("修改转运站")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "客户经理" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.preSaleDeliveryRecord
                                          .userCustomerManagerName,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "佣金比例" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.preSaleDeliveryRecord
                                          .salesAssociateCommissionPercent,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "8" } },
                            [
                              _vm.$checkAccessArray(["S", "B", "D"])
                                ? _c(
                                    "FormItem",
                                    { attrs: { label: "客户备注" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.preSaleDeliveryRecord
                                              .customerMsg,
                                          readonly: "",
                                          type: "textarea",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "8" } },
                            [
                              _vm.$checkAccessArray(["S", "B", "D"])
                                ? _c(
                                    "FormItem",
                                    { attrs: { label: "撤销原因" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.preSaleDeliveryRecord
                                              .cancelReason,
                                          readonly: "",
                                          type: "textarea",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _vm.$checkAccessArray(["B", "C"])
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        "text-align": "right",
                                      },
                                    },
                                    [
                                      this.preSaleDeliveryRecord
                                        .preSaleDeliveryRecordStatus == -1
                                        ? _c(
                                            "Poptip",
                                            {
                                              staticStyle: {
                                                "text-align": "left",
                                                "margin-right": "10px",
                                              },
                                              attrs: {
                                                confirm: "",
                                                placement: "left",
                                                title: "请确认信息是否无误？",
                                              },
                                              on: {
                                                "on-ok": _vm.updateOrder,
                                                "on-cancel": _vm.cancel,
                                              },
                                            },
                                            [
                                              _c(
                                                "Button",
                                                { attrs: { type: "info" } },
                                                [_vm._v("批量保存修改")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      this.preSaleDeliveryRecord
                                        .preSaleDeliveryRecordStatus == 0
                                        ? _c(
                                            "Poptip",
                                            {
                                              staticStyle: {
                                                "text-align": "left",
                                              },
                                              attrs: {
                                                confirm: "",
                                                placement: "left",
                                                title: "请确认信息是否无误？",
                                              },
                                              on: {
                                                "on-ok":
                                                  _vm.saveReceiveQuantity,
                                                "on-cancel": _vm.cancel,
                                              },
                                            },
                                            [
                                              _c(
                                                "Button",
                                                { attrs: { type: "error" } },
                                                [_vm._v("保存发货量")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "FormItem",
                                [
                                  _c(
                                    "div",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [_c("b", [_vm._v("发货单明细")])]
                                  ),
                                  _c("Table", {
                                    ref: "productTable",
                                    attrs: {
                                      size: "small",
                                      columns: _vm.productTable.columns,
                                      data: _vm.preSaleDeliveryDetails,
                                      stripe: "",
                                      border: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Modal",
            {
              attrs: {
                title: "修改转运站",
                "class-name": "vertical-center-modal",
                width: "400",
              },
              model: {
                value: _vm.distributionStation.Show,
                callback: function ($$v) {
                  _vm.$set(_vm.distributionStation, "Show", $$v)
                },
                expression: "distributionStation.Show",
              },
            },
            [
              _c("Loading", { attrs: { isLoading: _vm.saveLoading } }),
              _c(
                "Form",
                { attrs: { "label-position": "top" } },
                [
                  _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "12" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "选择转运站:" } },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { filterable: "", clearable: "" },
                                  model: {
                                    value:
                                      _vm.distributionStation
                                        .relateDistributionStationUuid,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.distributionStation,
                                        "relateDistributionStationUuid",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "distributionStation.relateDistributionStationUuid",
                                  },
                                },
                                _vm._l(_vm.stationList, function (item, index) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.distributionStationUuid,
                                      attrs: {
                                        value: item.distributionStationUuid,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(item.distributionStationName)
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "Button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.updateShippedDistributionStation },
                    },
                    [_vm._v("确认")]
                  ),
                  _c(
                    "Button",
                    {
                      attrs: { type: "error" },
                      on: {
                        click: function ($event) {
                          _vm.distributionStation.Show = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }